
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../../directives/directives.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';

import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { CHANGE_STATUS_SITUATION } from './change.situation.component';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TabViewModule } from 'primeng-lts/tabview';


@NgModule({
  declarations: [CHANGE_STATUS_SITUATION],
  imports: [TranslateModule, CommonModule, FormsModule,
    DynamicDialogModule,
    DirectivesModule, WaitLoadingModule, A11yModule,
    FormPlycaModule,
    // HelpModule,
    SubHeaderModule, ScrollPanelModule, TabViewModule],
  exports: [CHANGE_STATUS_SITUATION]
})
export class ChangeStatusSituationModule { }
